import { HotelsSearchParamsRoom } from "../../../types/HotelsSearchParams";
import {
  CHILD_AGE_SELECT_ID_PATTERN,
  ROOM_CHILD_INDEX_PLACEHOLDER,
  ROOM_INDEX_PLACEHOLDER,
} from "./constants";

export const getFirstInvalidChildAgeElementId = (roomValues: HotelsSearchParamsRoom[]) => {
  const roomIndex = roomValues.findIndex((room) =>
    room.childrenAge.some((childAge) => typeof childAge !== "number")
  );
  const childIndex = roomValues[roomIndex].childrenAge.findIndex(
    (childAge) => typeof childAge !== "number"
  );
  return getRoomChildAgeElementId(roomIndex, childIndex);
};

export const getRoomChildAgeElementId = (roomIndex: number, childIndex: number) => {
  return CHILD_AGE_SELECT_ID_PATTERN.replace(ROOM_INDEX_PLACEHOLDER, roomIndex.toString()).replace(
    ROOM_CHILD_INDEX_PLACEHOLDER,
    childIndex.toString()
  );
};
